<template>
    <modal @close="addFundsCancelClick" class="edit-modal" hideFooter id="add-funds-promotion">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Add Funds</h3>
                    <div class="mt-3">
                        <p>
                            You can manually add additional funds to your promotion anytime by completing this form.
                        </p>
                        <p>Once funds are added, TruckDown will automatically email you a receipt and the funds will be applied immediately to the promotion.</p>
                        <p>
                            Alternately, you can always setup an automated promotion funding schedule using the "Set-up Recurring Charge" option.
                        </p>
                    </div>
                </div>
            </div>
            <div class="edit-pages">
                <form>
                    <div class="md-col-2 mt-5 mb-2" v-if="displayAddCreditCard == false">
                        <div>
                            <div>
                                <label class="td-label td-text-bold">Amount to Add ($):</label>
                                <input type="number" placeholder="" @change="validate" :class="[{'error': displayError['amount']}, {'disabled': applyCreditToPromotion === true}]" v-model="amount" :disabled="applyCreditToPromotion === true" />
                                <error v-if="displayError['amount']" :error="errors['amount']"></error>
                            </div>
                            <div class="mt-3" v-if="showTaxes">
                                <label class="td-label td-text-bold">Taxes ( {{ taxName }}):</label>
                                <p class="pa-0 ma-0">${{ taxes }}</p>
                            </div>

                            <div class="mt-3">
                                <label v-if="!applyCreditToPromotion" class="td-label td-text-bold">Total Amount to be Charged:</label>
                                <label v-if="applyCreditToPromotion" class="td-label td-text-bold">Total Amount to be Applied:</label>
                                <p class="pa-0 ma-0">{{ totalCharge }}</p>
                            </div>
                        </div>
                        <div>
                            <div v-if="applyCreditToPromotion === false">
                                <label class="td-label td-text-bold">Select credit card or enter card information:</label>
                                <select v-model="selectedCreditCard" class="td-select" @change="creditCardChange">
                                    <option :value="undefined">Enter Card Information</option>
                                    <option v-if="isCsrOrAdmin()" :value="PaymentMethod.Check">Cheque</option>
                                    <option v-if="creditCards" v-for="(creditCard, index) in creditCards" :value="creditCard" :key="index">
                                        {{ creditCard.numberDisplay }}
                                        <span v-if="creditCard.isPrimary">(Primary)</span>
                                    </option>
                                </select>
                                <error v-if="displayError['selectedCreditCard']" :error="errors['selectedCreditCard']"></error>
                            </div>
                            <div v-if="applyCreditToPromotion === false" class="code mt-3 mb-2">
                                <label class="td-label td-text-bold">Security Code:</label>
                                <input v-model="securityCode" @change="validate" :class="[{'error': displayError['securityCode']}]" type="text" placeholder="e.g. 123" />
                                <error v-if="displayError['securityCode']" :error="errors['securityCode']"></error>
                            </div>

                            <div v-if="accountCredit > 0" class="mt-3">
                                <label class="td-label td-text-bold">Account Credit:</label> {{ new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(accountCredit) }}
                            </div>

                            <div v-if="accountCredit > 0" class="mt-3">
                                <label class="td-checkbox-label td-text-bold">
                                    Apply Credit to Promotion
                                    <input name="applyCreditToPromotion" type="checkbox" v-model="applyCreditToPromotion" @change="applyCreditToPromotionChange" />
                                    <span></span>
                                </label>

                            </div>

                        </div>


                    </div>
                    <div v-if="displayAddCreditCard == true" class="mb-5 mb-2">
                        <h3>Add Credit Card</h3>
                        <add-credit-card :accountid="promotion.accountId" @save="addCreditCardSave" @cancel="addCreditCardCancel"></add-credit-card>
                    </div>
                </form>


                <div class="actions">
                    <div>
                        <button v-if="displayAddCreditCard == false" class="td-btn primary-outlined" @click="addFundsCancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button v-if="displayAddCreditCard == false" class="td-btn btn primary" @click="addFundsSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Add Funds</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './AddFunds';
    export default script;
</script>
<style lang="less">
    @import './AddFunds.less';
</style>